// extracted by mini-css-extract-plugin
export default {"input":"styles_input__n8Bw2","error-border":"styles_error-border__qHEyc"};